import debounce from "lodash.debounce";

function SmoothAnchorScroll() {
 // ヘッダーの高さを取得
 function getHeaderHeight() {
  const getOffsetHeight = (selector) => {
   const element = document.querySelector(selector);
   return element ? element.offsetHeight : 0;
  };

  const headerHeight = getOffsetHeight(".--fixed-header");
  return headerHeight;
 }

 // イージング関数
 function easing(t, b, c, d) {
  if ((t /= d / 2) < 1) return (c / 2) * t * t * t + b;
  return (c / 2) * ((t -= 2) * t * t + 2) + b;
 }
 //  function easing(t, b, c, d) {
 //   return t === d ? b + c : c * (-Math.pow(2, (-10 * t) / d) + 1) + b;
 //  }

 // リサイズ時にヘッダーの高さを再取得
 function handleResize() {
  headerHeight = getHeaderHeight();
  //   console.log("header height after resize: ", headerHeight); // リサイズ後の高さをログ出力
 }

 // スムーススクロール
 function smoothScrollTo(target, headerHeight) {
  const scrollStopTop = target.getBoundingClientRect().top - headerHeight;
  const scrollTop = window.scrollY || document.documentElement.scrollTop;
  const start = new Date().getTime();
  const animeSpeed = 1500;

  // メインアニメーションループ
  function mainAnime() {
   const currentTime = new Date().getTime();
   const elapsedTime = currentTime - start;

   if (elapsedTime > animeSpeed) {
    window.scrollTo(0, scrollTop + scrollStopTop);
    document.body.classList.remove("is-scroll-busy");
    return;
   }

   const newScrollTop = easing(elapsedTime, scrollTop, scrollStopTop, animeSpeed);

   window.scrollTo(0, newScrollTop);
   requestAnimationFrame(mainAnime);
  }

  requestAnimationFrame(mainAnime);
 }

 // アンカーリンクのイベントリスナー
 function addTargetClickListener(target, headerHeight) {
  target.addEventListener("click", function (event) {
   event.preventDefault();

   if (document.body.classList.contains("is-scroll-busy")) {
    return;
   }
   document.body.classList.add("is-scroll-busy");

   const href = target.getAttribute("href");
   const targetId = href.substring(1);
   const targetElement = document.getElementById(targetId);
   const scrollStopTarget = document.querySelector(href === "#" ? "html" : href) || document.body;

   smoothScrollTo(scrollStopTarget, headerHeight);

   targetElement.focus();
  });
 }

 let headerHeight = getHeaderHeight();
 //  console.log(".--fixed-header height: ", headerHeight); // 初期の高さをログ出力

 window.addEventListener("resize", debounce(handleResize, 200));

 const targets = Array.from(document.querySelectorAll('a[href^="#"]'));
 targets.forEach((target) => addTargetClickListener(target, headerHeight));

 window.addEventListener("DOMContentLoaded", (_event) => {
  const urlHash = location.hash;

  if (urlHash) {
   setTimeout(() => {
    const urlTarget = document.getElementById(urlHash.replace("#", ""));
    if (urlTarget) {
     const urlPosition = window.scrollY + urlTarget.getBoundingClientRect().top - headerHeight;
     window.scrollTo(0, urlPosition);
    }
   }, 1000);
  }
 });
}

// DOMが完全にロードされた後にスクリプトを実行
document.addEventListener("DOMContentLoaded", () => {
 SmoothAnchorScroll();
});

export default SmoothAnchorScroll;
